import { Component, Mixins } from "vue-property-decorator";
import RequestsMixin from "@/mixins/http/RequestsMixin";
import CompanyMixin from "@/mixins/http/CompanyMixin";

@Component
class CompanyService extends Mixins(CompanyMixin, RequestsMixin) {}

export default new CompanyService();
